<div mat-dialog-content> 
    <!-- <span class="close-btn" (click)="close('close')">Close</span>  -->
    <div>
    <div class="borderBox">
        <div class="row"  *ngFor="let product of cartProducts">
           
            <div class="col-lg-4">
                <div class="imagediv"                    
                    [ngStyle]="{'background-image':' url( ' + product.product_data.media_url + ' )'}">
                </div>
            </div>
            <div class="col-8">
                <span *ngIf=" product.product_data.name.length <= 20" class="pointer">{{ product.product_data.name }}
                </span>
                <span *ngIf=" product.product_data.name.length > 20" matTooltipPosition="above"
                    matTooltip="{{ product.product_data.name }}" class="pointer">
                    {{ product.product_data.name  | slice: 0:20}}
                    {{ product.product_data.name.length > 20 ? "..." : ""}}
                </span>
             
                <div>
                <span *ngIf="product.product_data.short_description.length <= 30" class="pointer">{{product.product_data.short_description}}
                </span>
                <span *ngIf="product.product_data.short_description.length > 30" matTooltipPosition="above"
                    matTooltip="{{product.product_data.short_description}}" class="pointer">
                    {{product.product_data.short_description  | slice: 0:30}}
                    {{product.product_data.short_description.length > 30 ? "..." : ""}}
                </span>
                </div>                            
                 <div class="mb-2">                   
                     {{ product.product_data.brand_name}} 
                </div> 

                <div *ngFor="let attr of product.product_data.attributes">                  

                    {{attr.attribute_name}} - {{attr.selected_attr}}
                </div>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <button class="checkoutButton" mat-flat-button (click)="gotoCheckout()">
            Checkout
        </button>
    </div>
    </div>
</div>